import Editor, {EditorOptions, ViewerOptions} from '@toast-ui/editor'
import Viewer from '@toast-ui/editor/dist/toastui-editor-viewer'
import '@toast-ui/editor/dist/toastui-editor.css'
import '@toast-ui/editor/dist/toastui-editor-viewer.css'
//Depois do CSS do Toast UI, para vencê-lo: a tipografia dos campos (ver o arquivo)
import '@/styles/markdown.css'

/**
 * O único lugar que sabe alcançar o Toast UI.
 *
 * O Viewer vem pelo caminho do arquivo, e não por '@toast-ui/editor': o entry principal
 * exporta só o Editor, e importar Viewer de lá compila mas quebra em tempo de execução.
 * O `exports` do pacote mapeia esse caminho, então o webpack 5 o resolve.
 *
 * Quem usa: os componentes MarkdownEditor e MarkdownViewer, e o markdownExcerpt, que
 * parseia pelo Viewer sem desenhar nada na tela.
 *
 * `usageStatistics: false` em tudo: o padrão do Toast UI é true, e aí cada construção
 * dispara um hit para o Google Analytics deles. Nenhum campo de formulário tem por que
 * falar com a rede.
 */

export type {Editor, Viewer}

export function createEditor(el: HTMLElement, options: Omit<EditorOptions, 'el'>): Editor {
    return new Editor({...options, el, usageStatistics: false})
}

export function createViewer(el: HTMLElement, options: Omit<ViewerOptions, 'el'> = {}): Viewer {
    return new Viewer({...options, el, usageStatistics: false})
}
